import { Truck, Package, Wrench, Trash2, HardHat } from "lucide-react";

export const SERVICES = [
  { id: "white_glove_delivery", name: "Delivery", icon: Package, blurb: "Premium white-glove handling deliveries. Room-of-choice or threshold placement available.", from: "$120" },
  { id: "moving", name: "Moving", icon: Truck, blurb: "Full-service residential and long-distance moving with flat-rate precision.", from: "$250" },
  { id: "furniture_assembly", name: "Furniture Assembly", icon: Wrench, blurb: "Assemble or disassemble furniture.", from: "$100" },
  { id: "junk_removal", name: "Junk Removal", icon: Trash2, blurb: "We'll get rid of it — donation first, dump is the last option.", from: "$150" },
  { id: "labor", name: "Labor", icon: HardHat, blurb: "Vetted, professional crews for loading, unloading, and on-site muscle.", from: "$120" },
];

export const serviceName = (id) => SERVICES.find((s) => s.id === id)?.name || (id || "").replace(/_/g, " ");

export const BOOK_SERVICES = [
  { id: "white_glove_delivery", name: "Delivery", icon: Package, blurb: "Premium white-glove handling deliveries. Room-of-choice or threshold placement." },
  { id: "moving", name: "Move", icon: Truck, blurb: "Homes and apartments — local or long distance, handled end to end." },
  { id: "furniture_assembly", name: "Assemble", icon: Wrench, blurb: "Assemble or disassemble furniture." },
  { id: "junk_removal", name: "Removal", icon: Trash2, blurb: "We'll get rid of it — donation first, dump is the last option." },
  { id: "labor", name: "Labor", icon: HardHat, blurb: "Vetted muscle for loading, unloading, and on-site work." },
];

export const BOOK_SIZES = [
  { id: "single", name: "Single item", desc: "One piece — sofa, treadmill, dresser" },
  { id: "few", name: "A few items", desc: "2–5 pieces" },
  { id: "studio", name: "Studio / 1BR", desc: "Compact space" },
  { id: "2br", name: "2 Bedroom", desc: "Standard apartment or condo" },
  { id: "3br", name: "3 Bedroom", desc: "Full household" },
  { id: "whole_house", name: "Whole house", desc: "4BR+ or estate scope" },
];

export const STAGES = [
  { id: "new_lead", name: "New Lead" },
  { id: "contacted", name: "Contacted" },
  { id: "quote_sent", name: "Quote Sent" },
  { id: "negotiation", name: "Negotiation" },
  { id: "booked", name: "Booked" },
  { id: "confirmed", name: "Confirmed" },
  { id: "assigned", name: "Assigned" },
  { id: "in_progress", name: "In Progress" },
  { id: "completed", name: "Completed" },
  { id: "paid", name: "Paid" },
  { id: "review_requested", name: "Review Requested" },
  { id: "archived", name: "Archived" },
];

export const MISSION_STATUSES = ["pending", "booked", "confirmed", "assigned", "in_progress", "completed", "cancelled"];

export const STATUS_STYLES = {
  new_lead: "bg-blue-500/10 text-blue-500 border-blue-500/30",
  contacted: "bg-sky-500/10 text-sky-500 border-sky-500/30",
  quote_sent: "bg-teal-500/10 text-teal-600 dark:text-teal-400 border-teal-500/30",
  negotiation: "bg-amber-500/10 text-amber-600 dark:text-amber-400 border-amber-500/30",
  booked: "bg-blue-500/10 text-blue-500 border-blue-500/30",
  confirmed: "bg-indigo-500/10 text-indigo-500 border-indigo-500/30",
  assigned: "bg-yellow-500/10 text-yellow-600 dark:text-yellow-400 border-yellow-500/30",
  in_progress: "bg-teal-500/15 text-teal-600 dark:text-teal-300 border-teal-500/40",
  completed: "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border-emerald-500/30",
  paid: "bg-green-500/10 text-green-600 dark:text-green-400 border-green-500/30",
  review_requested: "bg-purple-500/10 text-purple-500 border-purple-500/30",
  archived: "bg-slate-500/10 text-slate-400 border-slate-500/20",
  quoted: "bg-teal-500/15 text-teal-600 dark:text-teal-300 border-teal-500/40",
  declined: "bg-slate-500/10 text-slate-400 border-slate-500/20",
  cancelled: "bg-red-500/10 text-red-500 border-red-500/30",
  open: "bg-sky-500/10 text-sky-500 border-sky-500/30",
  filled: "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border-emerald-500/30",
  overdue: "bg-rose-500/15 text-rose-500 border-rose-500/40",
  pending: "bg-amber-500/10 text-amber-600 dark:text-amber-400 border-amber-500/30",
  draft: "bg-slate-500/10 text-slate-400 border-slate-500/20",
  available: "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border-emerald-500/30",
  on_mission: "bg-teal-500/15 text-teal-600 dark:text-teal-300 border-teal-500/40",
  off_duty: "bg-slate-500/10 text-slate-400 border-slate-500/20",
  ready: "bg-blue-500/10 text-blue-500 border-blue-500/30",
  in_service: "bg-teal-500/15 text-teal-600 dark:text-teal-300 border-teal-500/40",
  maintenance: "bg-orange-500/10 text-orange-600 dark:text-orange-400 border-orange-500/30",
  priority: "bg-purple-500/15 text-purple-600 dark:text-purple-400 border-purple-500/40",
  requested: "bg-amber-500/10 text-amber-600 dark:text-amber-400 border-amber-500/30",
  submitted: "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border-emerald-500/30",
};

export const ZONE_LABELS = {
  same_place: "Same location — on-site",
  chula_vista: "Chula Vista", eastlake: "Eastlake", downtown: "Downtown San Diego",
  mission_valley: "Mission Valley", la_jolla: "La Jolla", el_cajon: "El Cajon",
  poway: "Poway", del_mar: "Del Mar", oceanside: "Oceanside", encinitas: "Encinitas",
  temecula: "Temecula", los_angeles: "Los Angeles", las_vegas: "Las Vegas", santa_barbara: "Santa Barbara",
};

export const EXPENSE_LABELS = {
  fuel: "Fuel & Gas", vehicle: "Vehicles", maintenance: "Maintenance",
  equipment: "Equipment & Tools", software: "Software & Website", marketing: "Marketing",
  insurance: "Insurance", tax: "Taxes", other: "Other",
};

export const COMPANY = {
  name: "CastleCorp",
  email: "contact@castle-corp.com",
  areas: "San Diego & Oceanside · Long distance to LA & Vegas",
  insured: "Insured up to $1M",
};
